<template>
    <div class="item-hut-rewards-card" :title="item.title">
      <img v-if="item.logo" class="image-item" :src="item.logo" />
      <div class="content-item d-flex flex-column">
          <p class="text-title mb-1" v-html="item.title"></p>
          <p class="text-price mb-2">
          <img class="image-icon mr-2" src="https://static.phdvasia.com/jp/hut-rewards/left_icon.png" />
          <span v-html="item.price"></span>
          </p>
          <button
          :class="
              item.isDisabled || isMaxRedeem
              ? 'btn btn-sm btn--secondary w-100'
              : 'btn btn-sm btn-danger w-100'
          "
          :disabled="item.isDisabled || isMaxRedeem"
          @click="$emit('fncRedeem')"
          >{{$t('button_redeem')}}</button>
      </div>
    </div>
</template>

<script>
import * as types from '@/store/types'
import { mapGetters } from 'vuex'

export default {
  name: 'CardItem',
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    isMaxRedeem: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      disableItemHutReward: types.GET_DISABLE_ITEM_HUT_REWARD
    })
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.item-hut-rewards-card {
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  margin-bottom: 20px;
  cursor: pointer;
}
.item-hut-rewards-card .image-item {
  height: 100px;
  width: 100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.item-hut-rewards-card .content-item {
  padding: 10px;
  background-color: white;
}
.item-hut-rewards-card .text-title {
  color: #231f20;
  font-weight: 600;
  font-size: 14px;
  text-align: left;
  display: block;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
.item-hut-rewards-card .text-price {
  text-align: left;
  font-size: 14px;
  color: #c8102e;
}
.btn-disabled {
  color: #231f20;
    background-color: #f5f7f9;
    border: 1px solid #b5b6bd;
}
@media (max-width: 768px) {
  .item-hut-rewards-card .image-item {
    height: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cards/CardItem.vue